//var event = new CustomEvent('loadForm');

document.addEventListener("pjax:complete", function () {

   /* trigger loadForm event to load scripts */
   if (jQuery(".gform_wrapper").length) {

      jQuery(".gform_wrapper").each(function(){
         var $formId = jQuery(this).attr('id').replace('gform_wrapper_', '');
         jQuery(document).trigger('gform_post_render', $formId);
      });


      /* if form has a datepicker field, load it */
      if (jQuery(".datepicker").length) {
         gformInitDatepicker();
         jQuery('.datepicker').attr('readonly', '');
      }
   }

   /* if form has a reCaptcha field installed, load all scripts */
   if (jQuery(".ginput_recaptcha").length && !jQuery("#gform_recaptcha-js").length) {
      jQuery('body').append('<script type="text/javascript" src="https://www.google.com/recaptcha/api.js?hl=nl&amp;render=explicit" defer="" onload="" id="gform_recaptcha-js"></script>')
   }

});

document.addEventListener("DOMContentLoaded", function () {

   if (jQuery(".gform_wrapper").length) {
      if (jQuery(".datepicker").length) {
         jQuery('.datepicker').attr('readonly', '');
      }
   }

   jQuery(document).bind('gform_post_render', function () {
      var gfRecaptchaPoller = setInterval(function () {
         if (!window.grecaptcha || !window.grecaptcha.render) {
            return;
         }
         renderRecaptcha();
         clearInterval(gfRecaptchaPoller);
      }, 100);
   });

   jQuery(document).bind('gform_post_render', function () {
      if (jQuery('.file-upload .ginput_preview').length) {
         var file = jQuery('.file-upload .ginput_preview strong').text();
         if (!jQuery('.file-upload .gfield_description.validation_message').length) {
            jQuery('.file-upload .gfield_description:before').css('content', file);
         }
      }
      jQuery('div.gfield').unbind('click').click(function () {
         jQuery(this).find('.validation_message').fadeOut();
      });
   });

});

jQuery(document).on('change', '.file-upload input[type=file]', function () {
   var file = jQuery(this).val().split('\\').pop();
   jQuery(this).closest('.file-upload').find('.gfield_description').html(file);
});
